import { IActivityHistoryItem, IActivityHistoryItemWithComponent } from "./model";

export function shouldShowRole(item: IActivityHistoryItem): boolean {
  return !item.professional?.speciality?.description;
}

export const hasItemDivider = (
  item: IActivityHistoryItemWithComponent,
  items: IActivityHistoryItemWithComponent[],
): boolean => {
  const currentIndex = items.findIndex((i) => i.id === item.id);

  if (currentIndex === -1) {
    // Item no encontrado, por seguridad
    return false;
  }

  if (currentIndex === items.length - 1) {
    // Es el último elemento
    return true;
  }

  return !item.diagnostics?.length;
};
